module.exports = __webpack_public_path__ + "img/mini_qrcode.4b8cef3.jpg";